import React, {useState, useEffect} from 'react'
import styled from 'styled-components';
import { fetchWrapper } from 'utils/apihandlers';
import InputComp from 'components/InputComp'
import TextboxComp from 'components/TextboxComp'
import Button from 'components/Button'
import SmallButton from 'components/SmallButton'
import HorizontalLine from 'components/horizontalLine/HorizontalLine';
import { PDFDocument, rgb, PageSizes, StandardFonts, drawText } from "pdf-lib";
import { formatDollar, getLine, formatDate } from 'utils/helperfunctions';
import download from 'downloadjs'
import ReadNoticesComp from "components/readNoticesComp"
import LoadingComponent from 'components/LoadingComponent';
// import ScrapeImageProp from "components/scrapeImageProp"

interface Prop{
    countyname: string;
    openModal: (header: any, message: any, progress?: any)=>void;
    properties: any;
    setproperties: (p:any)=>void;
    setloading:(x:boolean)=>void;
	  loading: boolean;
}
const DisplayListingComps : React.FC<Prop>=({countyname, properties, setproperties, openModal, setloading, loading})=>{
    
    const [ apiloading, setapiloading ] = useState(false)
    
    const [ legaldescription, setlegaldescription ] = useState("")
    const [ lot, setlot ] = useState("")
    const [ block, setblock ] = useState("")
    const [ subdivision, setsubdivision ] = useState("")
    
    const [ address, setaddress ] = useState("")
    const [ auctiondate, setauctiondate ] = useState("")
    const [ searchownername, setsearchownername ] = useState("")
    const [ city, setcity ] = useState("")
    // const [ loading, setloading ] = useState(false)
    // const [ loadingdeed, setloadingdeed ] = useState(false)
    
    const [ selectedprop, setselectedprop ] = useState(-1)
    const [ selectedIdx, setselectedIdx ] = useState(-1)
    const [ propid, setpropid ] = useState(-1)
    const [ deeddownloadprogressmsg, setdeeddownloadprogressmsg ] = useState("")

    const [ showmissingdeeds, setshowmissingdeeds ] = useState(false)
    
    
    const [ operationslog, setoperationslog ] = useState("")
    
    const [ foreclosuretype, setforeclosuretype ] = useState("mortgage")    
    const [ lienamount, setlienamount ] = useState("")
    const [ lienyear, setlienyear ] = useState("")
    const [ assessedValue, setassessedValue ] = useState<any>("")
    const [ improvementarea, setimprovementarea ] = useState("")
    const [ ownername, setownername ] = useState("")
    const [ propertytype, setpropertytype ] = useState("")
    
    const [ deednumber, setdeednumber ] = useState("")
    const [ deeddate, setdeeddate ] = useState("")
    const [ propertyid, setpropertyid ] = useState("")
    
    const [ propertylink, setpropertylink ] = useState("")
    const [ propdesc, setpropdesc ] = useState("")
    const [ street, setstreet ] = useState("")
    const [ addrcity, setaddrcity ] = useState("")
    const [ state, setstate ] = useState("")
    const [ zip, setzip ] = useState("")
    const [ yearbuilt, setyearbuilt ] = useState("")
	const [ lotsize, setlotsize ] = useState("")
	
    

    const [ trusteename, settrusteename ] = useState("")
    const [ trusteephone, settrusteephone ] = useState("")
    const [ searchtrusteename, setsearchtrusteename ] = useState("")
    const [ searchstreetname, setsearchstreetname ] = useState("")
    
    
    const [ favorite, setfavorite ] = useState(false)
    const [ searchfavorites, setsearchfavorites ] = useState(false)    
    const [ imageurl, setimageurl ] = useState<any>(null)
    const [ currentimageidx, setcurrentimageidx ] = useState(-1)
    
    const [ notice, setnotice ] = useState("")
    const [ deedsearchtext, setdeedsearchtext ] = useState("")
    const [ beds, setbeds ] = useState("")
    const [ baths, setbaths ] = useState("")
    const [ noticelink, setnoticelink ] = useState("")

    const [ parsedtext, setparsedtext ] = useState("")   

    const [ noticeFileName, setnoticeFileName ] = useState("")
    const [ uploadednoticeFileName, setuploadedNoticeFileName ] = useState("")
    const [ uploadednoticeFile, setuploadedNoticeFile ] = useState<any>(null)

    const [ tenam, settenam ] = useState(false)
    const [ elevenam, setelevenam ] = useState(false)
    const [ twelveam, settwelveam ] = useState(false)
    const [ oneam, setoneam ] = useState(false)
    const [ auctiontime, setauctiontime ] = useState("")
        
	const [ apiresult, setapiresult ] = useState("")
	
    const selectProp = (idx: any) => {

		setapiresult("")
		setlotsize(`${properties[idx].lotsize?properties[idx].lotsize:""}`)
        setparsedtext("")
        setselectedIdx(idx)
        setaddress(`${properties[idx].street}, ${properties[idx].city}, ${properties[idx].state}, ${properties[idx].zip}`)
        setlegaldescription(`${properties[idx].legaldescription}`)
        setlot(properties[idx].lot)
        setblock(properties[idx].block)
        setsubdivision(properties[idx].subdivision)
        setlienamount(properties[idx].defaultamount?properties[idx].defaultamount:"")
        setlienyear(properties[idx].lienyear?properties[idx].lienyear:"")
        setpropdesc(properties[idx].description?properties[idx].description:"")
        setassessedValue(properties[idx].appraisedvalue)
        setimprovementarea(properties[idx].improvementarea)
        setownername(properties[idx].ownername?properties[idx].ownername:"")
        setpropertytype(properties[idx].type)
        setdeednumber(properties[idx].deednumber)
        
        setdeeddate(properties[idx].deeddate)
        setpropertylink(properties[idx].propertyid?`http://www.collincad.org/propertysearch?prop_id=${properties[idx].propertyid}`:"http://www.collincad.org/propertysearch")
        setpropertyid(properties[idx].propertyid)
        getAddress(`${properties[idx].street}, ${properties[idx].city}, ${properties[idx].state}, ${properties[idx].zip} `)
        settrusteename(properties[idx].trusteename?properties[idx].trusteename:"")
        settrusteephone(properties[idx].trusteephone?properties[idx].trusteephone:"")
        setfavorite(properties[idx].favorite)
        setyearbuilt(properties[idx].yearbuilt)
        setdeedsearchtext(properties[idx].deednumber)
        setnotice(properties[idx].foreclosurenotice?properties[idx].foreclosurenotice:"")
        
        setbeds(properties[idx].beds?properties[idx].beds:"")
        setbaths(properties[idx].baths?properties[idx].baths:"")
        setforeclosuretype(properties[idx].foreclosuretype)
        setnoticelink(properties[idx].noticelink?properties[idx].noticelink:"")
        setnoticeFileName(properties[idx].noticefiletag?properties[idx].noticefiletag:"")
        setuploadedNoticeFile(null)
        setuploadedNoticeFileName("")
        
        setauctiontime(properties[idx].auctiontime?properties[idx].auctiontime:"")
        settenam(false)
        setelevenam(false)
        settwelveam(false)
        setoneam(false)

        if(properties[idx].images && properties[idx].images.length>0){

          let response: any = showImage(properties[idx].images[0])
          setcurrentimageidx(0)
        }else{
          setimageurl(null)
          setcurrentimageidx(-1)
        }
    }

    const showpreviousimage = async () => {
      if((currentimageidx-1)>=0){
        await showImage(properties[selectedIdx].images[currentimageidx-1])
        setcurrentimageidx(currentimageidx-1)
      }
    }

    const shownextimage = async () => {
      if((currentimageidx+1)<properties[selectedIdx].images.length){
        await showImage(properties[selectedIdx].images[currentimageidx+1])
        setcurrentimageidx(currentimageidx+1)
      }
    }

    const showImage = async (imagename: any) => {
      let body = {
        imagename:imagename
      }
      // console.log(`body : ${JSON.stringify(body)}`)
      try{
        var response = await fetchWrapper.post("/api/admin/showimage", {imagename: imagename}).then((r: any)=>r)
        setimageurl(response.data.url)
      }catch(error){}

      
    }

    const getAddress = (address: any) => {
      const regex = /([\dA-Za-z\s]+)[,]?[\s+]?([A-Za-z\s]+)[,]?[\s+]?([A-Za-z]{2})[,]?[\s+]?(\d{5})/i;
      // const regex = /([0-9A-Za-z\s]+),\s*([A-Za-z\s]+),\s*([A-Z]{2}),\s*(\d{5})/;
      const match = address.match(regex);
      let info: any = {}
      if (match) {
          setstreet(match[1].toUpperCase())
          setaddrcity(match[2].toUpperCase())
          setstate(match[3].toUpperCase())
          setzip(match[4].toUpperCase())
          // console.log(`here ${match.join("-")}`)
      }else{
        setstreet("")
        setaddrcity("")
        setstate("")
        setzip("")
      }
      
    }

    const changeaddress = (e: any) => {
        let address = e.target.value
        setaddress(address)
        address +=" "
        getAddress(address)
    }

    const updatepropinfo = async () => {
        setloading(true)

		if(countyname=="Cook County"){
			console.log(`cook county update`)
			
			var response = await fetchWrapper.post("/api/cookcountyapi/updateforeclosureprop", {id:properties[selectedIdx]._id, foreclosureid:properties[selectedIdx].foreclosureid,  description: propdesc, appraisedvalue: assessedValue, improvementarea: improvementarea, ownername: ownername, street: street, city: addrcity, state: state, zip: zip, trusteename:trusteename, trusteephone:trusteephone, favorite: favorite, type: propertytype, legaldescription: legaldescription, yearbuilt: yearbuilt, beds: beds, baths: baths, propertyid: propertyid, defaultamount: lienamount, foreclosuretype: foreclosuretype, noticelink:noticelink, auctiontime:auctiontime, status:"active"
			})
			setloading(false)
	
			properties[selectedIdx].propertyid = propertyid
			properties[selectedIdx].street = street
			properties[selectedIdx].city = addrcity
			properties[selectedIdx].state = state
			properties[selectedIdx].zip = zip
			properties[selectedIdx].defaultamount = lienamount
			properties[selectedIdx].lienamount = lienamount
			properties[selectedIdx].lienyear = lienyear
			properties[selectedIdx].description= propdesc
			properties[selectedIdx].appraisedvalue = assessedValue
			properties[selectedIdx].improvementarea = improvementarea
			properties[selectedIdx].ownername = ownername
			properties[selectedIdx].type = propertytype
			properties[selectedIdx].deednumber = deednumber
			properties[selectedIdx].deeddate = deeddate
			properties[selectedIdx].trusteename = trusteename
			properties[selectedIdx].trusteephone = trusteephone
			properties[selectedIdx].favorite = favorite
			properties[selectedIdx].yearbuilt = yearbuilt
			properties[selectedIdx].legaldescription = legaldescription
			properties[selectedIdx].beds = beds
			properties[selectedIdx].baths = baths
			properties[selectedIdx].foreclosuretype = foreclosuretype
			properties[selectedIdx].noticelink = noticelink
			selectProp(selectedIdx)
			setproperties(properties)

		}else{
        
			var response = await fetchWrapper.post("/api/foreclosureapi/updateforeclosureprop", {foreclosureid:properties[selectedIdx].foreclosureid, lienamount: lienamount, lienyear: lienyear, description: propdesc, appraisedvalue: assessedValue, improvementarea: improvementarea, ownername: ownername, deednumber: deednumber, deeddate: deeddate, propertylink: propertylink, street: street, city: addrcity, state: state, zip: zip, trusteename:trusteename, trusteephone:trusteephone, favorite: favorite, type: propertytype, legaldescription: legaldescription, yearbuilt: yearbuilt, beds: beds, baths: baths, propertyid: propertyid, defaultamount: lienamount, foreclosuretype: foreclosuretype, noticelink:noticelink, auctiontime:auctiontime,lot:lot, block:block, subdivision:subdivision,
			}).then(r=>r)
			setloading(false)
	
			properties[selectedIdx].propertyid = propertyid
			properties[selectedIdx].street = street
			properties[selectedIdx].city = addrcity
			properties[selectedIdx].state = state
			properties[selectedIdx].zip = zip
			properties[selectedIdx].defaultamount = lienamount
			properties[selectedIdx].lienamount = lienamount
			properties[selectedIdx].lienyear = lienyear
			properties[selectedIdx].description= propdesc
			properties[selectedIdx].appraisedvalue = assessedValue
			properties[selectedIdx].improvementarea = improvementarea
			properties[selectedIdx].ownername = ownername
			properties[selectedIdx].type = propertytype
			properties[selectedIdx].deednumber = deednumber
			properties[selectedIdx].deeddate = deeddate
			properties[selectedIdx].trusteename = trusteename
			properties[selectedIdx].trusteephone = trusteephone
			properties[selectedIdx].favorite = favorite
			properties[selectedIdx].yearbuilt = yearbuilt
			properties[selectedIdx].legaldescription = legaldescription
			properties[selectedIdx].beds = beds
			properties[selectedIdx].baths = baths
			properties[selectedIdx].foreclosuretype = foreclosuretype
			properties[selectedIdx].noticelink = noticelink
			properties[selectedIdx].lot = lot
			properties[selectedIdx].block = block
			properties[selectedIdx].subdivision = subdivision
			setproperties(properties)
		}
      }

      const insertdocblock = () => {
        let deedsearchtext = `[{
          "header":"",
          "documentNumber":"",
          "recordDate":"",
          "grantor":"",
          "grantee":"",
          "legaldesc":"",
          "valididx":,
          "documentStatus":"",
          "numberOfPages":"",
          "bookVolumePage":"",
          "instrumentDate":"",
          "description":"",
          "deeddocfileid":"",
          "doclinktag":"",
          "consideration":"[]"
        }]`
        setdeedsearchtext(deedsearchtext)
      }
  
  
      const createtitlePDF = async (foreclosureid: any) => {
        // openModal("Message", "Downloading deed file", true)
  
        let titleinfo: any = []
        try{
          titleinfo = JSON.parse(deedsearchtext)
        }catch(error){
          console.log(`${error}`)
          
          openModal("Warning", "Load deed document before proceeding!", false)
          return
        }
        if(titleinfo.length<1){
          openModal("Warning", "Get deed document before proceeding!", false)
          return 
        }
  
        try{
          
          await makeChainOfTitlePdf(titleinfo, address, foreclosureid)
        }catch(error){
          // openModal("Error", "Deed file does not exist", false)
          openModal("Error", `${error}`, false)
        }
      }
  
      const loadtitlefile = async () =>{
        try{
          let titleinfo: any = await fetchWrapper.post("/api/admin/foreclosureapi/loaddeeddocumenttext",{foreclosureid: properties[selectedIdx].foreclosureid}).then(info=> info)
          
          let txt: any = Buffer.from(titleinfo.data.data).toString()
  
          setdeedsearchtext(txt)
          
        }catch(error){
          openModal("Error", "Deed file does not exist", false)
        }
      }

      const DrawText = (
        page: any,
        font: any,
        value: string,
        xpos: number,
        ypos: number,
        fontSize: number
      ) => {
        const color = rgb(0, 0, 0)
        page.drawText(value, {
          x: xpos,
          y: ypos,
          size: fontSize,
          font: font,
          color: color,
        })
      }
  
      const DrawLine = (page: any, font: any, ypos: any) => {
        let txt = `____________________________________________________________________________`
        DrawText(page, font, txt, 50, ypos+7, 12)
      }
  
      const writeMultipleLines = (page: any, font: any, xpos: any, ypos: any, fontsize: any, linespacing: any,  text: any) => {
  
        let getnextline = true
        let line_idx = 0
        let lineswritten = 0
        while(getnextline){
          let line = getLine(text, 60)
          DrawText(page, font, `${line}`, xpos, ypos-line_idx*linespacing, fontsize)
          lineswritten++
          line_idx++
          if(line.length==text.length)
          {
            getnextline = false
            break
          }
          text = text.substring(line.length)
        }
        return lineswritten
        // DrawLine(page, font, ypos-20*4-12*line_idx)
      }

      const makeDeedDocBlock = async (page: any, font: any, blockinfo: any, ypos: any, pdfDoc: any) => {
      
        DrawText(page, font, blockinfo.header, 50, ypos, 16)
        DrawLine(page, font, ypos-10)
        DrawText(page, font, `Document#: ${blockinfo.documentNumber}`, 50, ypos-20*1, 10)
        let link = `https://collin.tx.publicsearch.us/doc/${blockinfo.doclinktag}`
        DrawText(page, font, `Date: ${blockinfo.instrumentDate}`, 50, ypos-15-20*1, 10)
        DrawText(page, font, `Recorded: ${blockinfo.recordDate}`, 175, ypos-15-20*1, 10)
        DrawText(page, font, `Book & Page: ${blockinfo.bookVolumePage}`, 400, ypos-10-20*1, 10)
        var lineswritten = writeMultipleLines(page, font, 50, ypos-12-19*2, 12, 13, `Grantee: ${blockinfo.grantee}`)
        var lineswritten2 = writeMultipleLines(page, font, 50, ypos-12-17*(3+lineswritten-1), 12, 13, `Grantor: ${blockinfo.grantor}`)
        lineswritten+=lineswritten2-1
        if(blockinfo.consideration)
        { 
          let consideration
          try{
            consideration = JSON.parse(blockinfo.consideration)
            // console.log(`here len ${consideration}`)
          
            if(consideration.length>0 && consideration[0]!="N/A"){
              // console.log(`blockinfo.consideration : ${JSON.stringify(consideration)}`)
              
              DrawText(page, font, `Balance: ${formatDollar(consideration[0])}`, 50, ypos-12-17*(3+lineswritten), 12)
            }
          }catch(error){
            console.log(`error ${error}, ${blockinfo.consideration}`)
          }
          
        }
      }

      const makeChainOfTitlePdf = async (titleinfo: any, propertyaddress: any, foreclosureid: any) => {

        const pdfDoc = await PDFDocument.create();
        const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
        let page = pdfDoc.addPage(PageSizes.Letter)
        let legal = titleinfo[0].legaldesc.split('Reference')[0]
        DrawText(page, helveticaFont, `Address: ${propertyaddress}`, 50, 715, 18)
        DrawText(page, helveticaFont, `Legal: ${legal}`, 50, 695, 14)
        DrawText(page, helveticaFont, `Owner: ${ownername}`, 50, 675, 14)
        DrawText(page, helveticaFont, `County: ${countyname}`, 50, 655, 14)
        
        let startY = 625
        let idx = 0
        let pagenumber = 0
        // console.log(`here total pages: ${titleinfo.length}`)
        
        for(let i=0; i<titleinfo.length; i++){
          // console.log(`here making page ${i}`)
          
          if((pagenumber==0 && i>0 && i%4==0)||(pagenumber>0 && idx>1 && idx%5==0)){
            page = pdfDoc.addPage(PageSizes.Letter)
            idx = 0
            startY = 700
            pagenumber++
          }
          await makeDeedDocBlock(page, helveticaFont, titleinfo[i], startY-idx*130, pdfDoc)
          idx++
        }
  
        const pdfBytes: any = await pdfDoc.save()
  
        var pdfblob = new Blob([pdfBytes], { type: "application/pdf" })
        let filename = address.split(" ").join("_")
        filename = foreclosureid
        download(pdfblob, `${filename}.pdf`)
  
      }

	  const parsenoticeimage = async () => {
	
			openModal("Uploading and reading file", "", true)
	
			var formData = new FormData()
	
			if (! uploadednoticeFile ) {
			openModal("Error", "Please select an notice file before proceeding.", false)
				return;
			}
	
			formData.append("file", uploadednoticeFile)
	
			let response = await fetchWrapper.postFile('/api/foreclosureapi/uploadandparsenoticeimage', formData)
			openModal("Done!", "Notice parsed", false)
			setuploadedNoticeFile(null)
			setuploadedNoticeFileName("")
			setnotice(response.text)
		}

	const noticeFileChange = (event: any) => {
        if (!event.target.files || event.target.files[0] == undefined) {
            setuploadedNoticeFileName("")
            setuploadedNoticeFile(null)
        } else {
            if(!event.target.files[0].type.includes('pdf')){
                openModal("Warning", "Invalid file type, only pdf files are allowed.")
                return
            }
            setuploadedNoticeFileName(event.target.files[0].name)
            setuploadedNoticeFile(event.target.files[0])
        }
    }

    const changeauctiontime = (time: any) => {
      switch(time){
        case 10:
          setauctiontime("10:00 AM")
          settenam(true)
          setelevenam(false)
          settwelveam(false)
          setoneam(false)
          return
        case 11:
          setauctiontime("11:00 AM")
          settenam(false)
          setelevenam(true)
          settwelveam(false)
          setoneam(false)
          return
        case 12:
          setauctiontime("12:00 PM")
          settenam(false)
          setelevenam(false)
          settwelveam(true)
          setoneam(false)
          return
        case 1:
          setauctiontime("1:00 PM")
          settenam(false)
          setelevenam(false)
          settwelveam(false)
          setoneam(true)
          return
        default:
          setauctiontime("")
          settenam(false)
          setelevenam(false)
          settwelveam(false)
          setoneam(false)
          return
  
  
  
      }
    }

	const CookCountyPropertyClassificationInfo = (code: any) => {
		if(code==100) return "Vacant Land"
		if(code==190) return "Minor Improvement on Vacant Land"
		if(code==200) return "Residential Land"
		if(code==202) return "One-story Residence"
		if(code==203) return "One-story Residence"
		if(code==204) return "One-story Residence"
		if(code==205) return "Two-or-more story residence"
		if(code==206) return "Two-or-more story residence"
		if(code==207) return "Two-or-more story residenc"
		if(code==208) return "Two-or-more story residence"
		if(code==209) return "Two-or-more story residence"
		if(code==210) return "Old style row house (townhome)"
		if(code==211) return "Apartment building with 2 to 6 units"
		if(code==212) return "Mixed-use commercial/residential building with apartment and commercial area"
		if(code==234) return "Split level residence"
		if(code==278) return "Two-or-more story residence"
		if(code==295) return "Individually owned townhome or row house"
		if(code==200) return "Residential land"
		if(code==201) return "Residential garage"
		if(code==213) return "Cooperative"
		if(code==218) return "A residential building licensed as a Bed & Breakfast"
		if(code==219) return "A residential building licensed as a Bed & Breakfast"
		if(code==224) return "Farm building"
		if(code==225) return "Single-room occupancy (“SRO”) rental building"
		if(code==236) return "Any residential area located on a parcel used primarily for commercial or industrial purposes "
		if(code==239) return "Non-equalized land under agricultural use, valued at farm pricing"
		if(code==240) return "First-time agricultural use of land valued at market price"
		if(code==241) return "Vacant land under common ownership with adjacent residence"
		if(code==288) return "Home improvement exemption"
		if(code==290) return "Minor improvement"
		if(code==297) return "Special residential improvements (may apply to condo building in first year of construction before division into individual units)"
		if(code==299) return "Residential condominium"
		if(code==300) return "Land used in conjunction with rental apartments"
		if(code==301) return "Ancillary structures used in conjunction with rental apartments (garage, mechanical structures, storage sheds, etc.)"
		if(code==313) return "Two-or-three story, building, seven or more units"
		if(code==314) return "Two-or-three-story, non-fireproof building with corridor apartment or California type apartments, no corridors, exterior entrance"
		if(code==315) return "Two-or-three story, non-fireproof corridor apartments or California type apartments, interior entrance"
		if(code==318) return "All mixed-use commercial/residential buildings "
		if(code==391) return "Apartment building over three stories, seven or more units"
		if(code==396) return "Rented modern row houses, seven or more units in a single development or one or more contiguous parcels in common ownership"
		if(code==397) return "Special rental structure"
		if(code==399) return "Rental condominium"
		if(code==400) return "Not-for-profit land"
		if(code==401) return "Not-for-profit ancillary structures used in conjunction with commercial non-profit improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==417) return "Not-for-profit one-story commercial building"
		if(code==418) return "Not-for-profit two-or-three story mixed-use commercial/ residential building"
		if(code==422) return "Not-for-profit one-story non-fireproof public garage "
		if(code==423) return "Not-for-profit gasoline station"
		if(code==426) return "Not-for-profit commercial greenhouse"
		if(code==427) return "Not-for-profit theatre"
		if(code==428) return "Not-for-profit bank building"
		if(code==429) return "Not-for-profit motel"
		if(code==430) return "Not-for-profit supermarket"
		if(code==431) return "Not-for-profit shopping center"
		if(code==432) return "Not-for-profit bowling alley"
		if(code==433) return "Not-for-profit Quonset hut or butler type building"
		if(code==480) return "Not-for-profit industrial minor improvement"
		if(code==481) return "Not-for-profit ancillary structures used in conjunction with industrial non-profit improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==483) return "Not-for-profit industrial Quonset hut or butler type building"
		if(code==487) return "Not-for-profit special industrial improvement"
		if(code==489) return "Not-for-profit industrial condominium"
		if(code==490) return "Not-for-profit commercial minor improvement"
		if(code==491) return "Not-for-profit improvement over three stories"
		if(code==492) return "Not-for-profit, two-or-three story building containing part of all retail and/or commercial space"
		if(code==493) return "Not-for-profit industrial building"
		if(code==496) return "Not-for-profit, rented modern row houses, seven or more units in a single development"
		if(code==497) return "Not-for-profit special structure"
		if(code==499) return "Not-for-profit condominium"
		if(code==500) return "Commercial land"
		if(code==501) return "Ancillary structures used in conjunction with commercial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==516) return "Non-fireproof hotel or rooming house (apartment hotel)"
		if(code==517) return "One-story, commercial building or area"
		if(code==522) return "Automotive related improvement"
		if(code==523) return "Gasoline station"
		if(code==526) return "Commercial greenhouse"
		if(code==527) return "Theatre"
		if(code==528) return "Bank building"
		if(code==529) return "Motel"
		if(code==530) return "Supermarket"
		if(code==531) return "Shopping center"
		if(code==532) return "Bowling alley"
		if(code==533) return "Quonset hut or butler type building"
		if(code==535) return "Golf course land/improvement"
		if(code==590) return "Commercial minor improvement"
		if(code==591) return "Commercial building over three stories"
		if(code==592) return "Two-or-three story building containing part of all retail and/or commercial space"
		if(code==597) return "Special commercial structure"
		if(code==599) return "Commercial condominium unit"
		if(code==550) return "Industrial land"
		if(code==580) return "Industrial minor improvement"
		if(code==581) return "Ancillary structures used in conjunction with industrial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==583) return "Industrial Quonset hut or butler type building"
		if(code==587) return "Special industrial improvement"
		if(code==589) return "Industrial condominium unit"
		if(code==593) return "Industrial building"
		if(code==651) return "Industrial land"
		if(code==663) return "Industrial building"
		if(code==670) return "Industrial minor improvement"
		if(code==671) return "Ancillary structures used in conjunction with industrial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==673) return "Industrial Quonset hut or butler type building"
		if(code==677) return "Special industrial improvement"
		if(code==679) return "Industrial condominium unit"
		if(code==681) return "Ancillary structures used in conjunction with industrial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==700) return "Commercial Incentive Land"
		if(code==701) return "Ancillary structures used in conjunction with commercial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==716) return "Non-fireproof hotel or rooming house (apartment hotel)"
		if(code==717) return "One-story commercial use building"
		if(code==722) return "Automotive related improvement"
		if(code==723) return "Gasoline station, with or without bays, store"
		if(code==726) return "Commercial greenhouse"
		if(code==727) return "Theatre"
		if(code==728) return "Bank building"
		if(code==729) return "Motel"
		if(code==730) return "Supermarket"
		if(code==731) return "Shopping center"
		if(code==732) return "Bowling alley"
		if(code==733) return "Quonset hut or butler type building"
		if(code==735) return "Golf course improvement"
		if(code==790) return "Minor commercial improvement"
		if(code==791) return "Office building"
		if(code==792) return "Two-or-three-story building containing part of all retail and/or commercial space"
		if(code==797) return "Special commercial structure"
		if(code==799) return "Commercial/Industrial condominium unit/garage"
		if(code==742) return "Commercial incentive land"
		if(code==743) return "Ancillary structures used in conjunction with commercial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==745) return "Golf course improvement"
		if(code==746) return "Non-fireproof hotel or rooming house (apartment hotel)"
		if(code==747) return "One-story commercial building"
		if(code==748) return "Motel"
		if(code==752) return "Automotive related improvement"
		if(code==753) return "Gasoline station, with or without bays, store"
		if(code==756) return "Commercial greenhouse"
		if(code==757) return "Theatre"
		if(code==758) return "Bank building"
		if(code==760) return "Supermarket"
		if(code==761) return "Shopping center (regional, community, neighborhood, promotional, specialty)"
		if(code==762) return "Bowling alley"
		if(code==764) return "Quonset hut or butler type building"
		if(code==765) return "Other minor commercial improvements"
		if(code==767) return "Special commercial structure"
		if(code==772) return "Two-or-three-story building, containing part or all retail and/or commercial space"
		if(code==774) return "Office building"
		if(code==798) return "Commercial/Industrial condominium units/garage"
		if(code==800) return "Commercial incentive land"
		if(code==801) return "Ancillary structures used in conjunction with commercial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==816) return "Non-fireproof hotel or rooming house (apartment hotel)"
		if(code==817) return "One-story commercial building"
		if(code==822) return "Automotive related improvement"
		if(code==823) return "Gasoline station with or without bays, store"
		if(code==827) return "Theatre"
		if(code==828) return "Bank building"
		if(code==829) return "Motel"
		if(code==830) return "Supermarket"
		if(code==831) return "Shopping center (regional, community, neighborhood, promotional, specialty)"
		if(code==832) return "Bowling alley"
		if(code==833) return "Quonset hut or butler type building"
		if(code==835) return "Golf course improvement"
		if(code==880) return "Minor industrial improvement"
		if(code==881) return "Ancillary structures used in conjunction with industrial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==890) return "Minor commercial improvement"
		if(code==891) return "Office building"
		if(code==892) return "Two-or-three-story building containing part of all retail and/or commercial space"
		if(code==893) return "Industrial building"
		if(code==897) return "Special commercial structure"
		if(code==899) return "Commercial/Industrial condominium unit/garage"
		if(code==900) return "Land used in conjunction with incentive rental apartments"
		if(code==901) return "Ancillary structures used in conjunction with rental apartments (garage, mechanical structures, storage sheds, etc.)"
		if(code==913) return "Two-or-three-story apartment building, seven or more units"
		if(code==914) return "Two-or-three-story non-fireproof court and corridor apartments or California type apartments, no corridors, exterior entrance"
		if(code==915) return "Two-or-three-story non-fireproof corridor apartments, or California type apartments, interior entrance"
		if(code==918) return "Mixed-use commercial/residential building with apartments and commercial area where the commercial area is granted an incentive use"
		if(code==959) return "Rental condominium unit"
		if(code==990) return "Other minor improvements"
		if(code==991) return "Apartment buildings over three stories"
		if(code==996) return "Rented modern row houses, seven or more units in a single development or one or more contiguous parcels in common ownership"
		if(code==997) return "Special rental structure"
		if(code==637) return "Commercial incentive land"
		if(code==638) return "Commercial incentive improvement"
		if(code==654) return "Other commercial or industrial minor improvements"
		if(code==655) return "Ancillary structures used in conjunction with commercial/industrial improvements (garage, mechanical structures, storage sheds, etc.)"
		if(code==666) return "Quonset hut or butler type building"
		if(code==668) return "Special commercial/industrial incentive improvement"
		if(code==669) return "Commercial/industrial condominium unit Major Class L (Reflected in Major Class 3, 4, 5, and 6) Historic Residence"
		return ""
	}

	const getResidentialData = async (id: any) => {
		if(id==""){
			openModal("Warning", "No PIN found!")
			return
		}
		id = id.replace(/\-/g, "")
		console.log(`id: ${id}`)
		setpropertyid(id)
		
		setapiloading(true)
		let dt = new Date()
		let year = dt.getFullYear()
		let month = dt.getMonth()
		if(month<3){
			year--
		}
		let response = await fetchWrapper.post("/api/cookcountyapi/getResidentialPropData", {pin: id, year: year})
		// console.log(`response : ${JSON.stringify(response.data.data)}`)		
		setapiresult(response.data.data)

		if(response.data.data.length>0){
			let data = response.data.data[0]
			setimprovementarea(data.char_bldg_sf=="No field"?"":data.char_bldg_sf)
			setlotsize(data.char_land_sf=="No field"?"":data.char_land_sf)
			setyearbuilt(data.char_yrblt=="No field"?"":data.char_yrblt)
			setbeds(data.char_beds=="No field"?"":data.char_beds)
			setbaths(data.char_fbath=="No field"?"":data.char_fbath)
			setpropertytype(data.char_use=="No field"?"":`${data.char_use}-` + CookCountyPropertyClassificationInfo(data.class))
		}

		setapiloading(false)
	}

	const getCondoData = async (id: any) => {
		if(id==""){
			openModal("Warning", "No PIN found!")
			return
		}
		setapiloading(true)
		let dt = new Date()
		let year = dt.getFullYear()
		let month = dt.getMonth()
		if(month<3){
			year--
		}
		let response = await fetchWrapper.post("/api/cookcountyapi/getCondoPropData", {pin: id, year: year})
		// console.log(`response : ${JSON.stringify(response.data.data)}`)		
		setapiresult(response.data.data)
		if(response.data.data.length>0){
			let data = response.data.data[0]
			setimprovementarea(data.char_bldg_sf=="No field"?"":data.char_bldg_sf)
			setlotsize(data.char_land_sf=="No field"?"":data.char_land_sf)
			setyearbuilt(data.char_yrblt=="No field"?"":data.char_yrblt)
			setbeds(data.char_beds=="No field"?"":data.char_beds)
			setbaths(data.char_fbath=="No field"?"":data.char_fbath)
			setpropertytype(data.char_use=="No field"?"" : CookCountyPropertyClassificationInfo(data.class))
		}
		setapiloading(false)
	}

	const getAppraisalData = async (id: any) => {
		if(id==""){
			openModal("Warning", "No PIN found!")
			return
		}
		setapiloading(true)
		let dt = new Date()
		let year = dt.getFullYear()
		let month = dt.getMonth()
		if(month<3){
			year--
		}
		let response = await fetchWrapper.post("/api/cookcountyapi/getPropertyAssessedValue", {pin: id, year: year})
		// console.log(`response : ${JSON.stringify(response.data.data)}`)		
		setapiresult(response.data.data)

		if(response.data.data.length>0){
			let data: any = response.data.data[0]
			setassessedValue(Number(data.certified_tot)*10)
		}
		setapiloading(false)
	}

	const getPinFromAddress = async (street: any, city: any, zip: any) => {
		setapiloading(true)
		let dt = new Date()
		let year = dt.getFullYear()
		let month = dt.getMonth()
		if(month<3){
			year--
		}
		let response = await fetchWrapper.post("/api/cookcountyapi/getPinFromAddress", {street: street, city: city, zip: zip, year: year})
		// console.log(`response : ${JSON.stringify(response.data.data)}`)
		if(response.data.data.length>0){
			setpropertyid(response.data.data[0].pin)
		}
		setapiresult(response.data.data)
		setapiloading(false)
	}

	const fetchAllPropPinAndData = async () => {
		
		setapiloading(true)
		let dt = new Date()
		let year = dt.getFullYear()
		let month = dt.getMonth()
		if(month<3){
			year--
		}
		for(let i=0; i<properties.length; i++){
			let improvementarea = ""
			let lotsize = ""
			let yearbuilt = ""
			let beds = ""
			let baths = ""
			let propertytype = ""
			let assessedValue: any = ""
			if(properties[i].propertyid==""){
				console.log(`foreclosureid: ${properties[i].foreclosureid}`)			

				let response = await fetchWrapper.post("/api/cookcountyapi/getPinFromAddress", {street: properties[i].street, city: properties[i].city, zip: properties[i].zip, year: year})

				if(response.data.data.length>0){
					let pin = response.data.data[0].pin
					console.log(`pin found: ${pin}`)
					
					response = await fetchWrapper.post("/api/cookcountyapi/getResidentialPropData", {pin: pin, year: year})

					if(response.data.data.length>0){
						let data = response.data.data[0]
						improvementarea = data.char_bldg_sf=="No field"?"":data.char_bldg_sf
						lotsize = data.char_land_sf=="No field"?"":data.char_land_sf
						yearbuilt = data.char_yrblt=="No field"?"":data.char_yrblt
						beds = data.char_beds=="No field"?"":data.char_beds
						baths = data.char_fbath=="No field"?"":data.char_fbath
						propertytype = data.char_use=="No field"?"":`${data.char_use}-` + CookCountyPropertyClassificationInfo(data.class)
					}else{
						response = await fetchWrapper.post("/api/cookcountyapi/getCondoPropData", {pin: pin, year: year})
						if(response.data.data.length>0){
							let data = response.data.data[0]
							improvementarea = data.char_bldg_sf=="No field"?"":data.char_bldg_sf
							lotsize = data.char_land_sf=="No field"?"":data.char_land_sf
							yearbuilt = data.char_yrblt=="No field"?"":data.char_yrblt
							beds = data.char_beds=="No field"?"":data.char_beds
							baths = data.char_fbath=="No field"?"":data.char_fbath
							propertytype = data.char_use=="No field"?"" : CookCountyPropertyClassificationInfo(data.class)
						}
					}
					response = await fetchWrapper.post("/api/cookcountyapi/getPropertyAssessedValue", {pin: pin, year: year})

					if(response.data.data.length>0){
						let data: any = response.data.data[0]
						assessedValue = Number(data.certified_tot)*10
					}
					await fetchWrapper.post("/api/cookcountyapi/updateforeclosureprop", {id:properties[i]._id, foreclosureid:properties[i].foreclosureid,  appraisedvalue: assessedValue, improvementarea: improvementarea, type: propertytype, yearbuilt: yearbuilt, beds: beds, baths: baths, propertyid: pin, status:"active"
					})
					// break
				}
			}
		}
		setapiloading(false)
	}

  

      useEffect(()=>{
        setselectedIdx(-1)
      },[properties])

	  useEffect(()=>{
        
      },[loading, apiresult])


  return(
    <MainContainer>
    <ButtonContainer>

		{countyname=="Cook County"?
			<Button text="update all" handleClick={()=>fetchAllPropPinAndData()} />
			:
			<>

				<ReadNoticesComp text="Read Selected Notice"  county={countyname} properties={properties} selectedIdx={selectedIdx} singleprop={true} setloadingdeed={setloading} setpropid={setpropid} setdeeddownloadprogressmsg={setdeeddownloadprogressmsg} setoperationslog={setoperationslog} openModal={openModal} smallbutton={true} width={100} setparsedtext={setparsedtext}/>

				<ReadNoticesComp text="Read All Notices"  county={countyname} properties={properties} selectedIdx={selectedIdx} singleprop={false} setloadingdeed={setloading} setpropid={setpropid} setdeeddownloadprogressmsg={setdeeddownloadprogressmsg} setoperationslog={setoperationslog} openModal={openModal} smallbutton={true} width={125} setparsedtext={setparsedtext} />
			</>
		}
    </ButtonContainer>

        {parsedtext!==""?<>
          <TextboxComp placeholder='Parsed Notice' id='parsednoticetb' value={parsedtext} onChange={(e: any)=>{}} rows={10} cols={50} width={500}/>
        </>
        :<></>}

    
        <div style={{margin:"5px 0"}}>#of properties: {properties.length}</div>

        <div style={{ width: '90%'}}>
            <Prop style={{ backgroundColor: 'lightgray', fontWeight: 700, padding: "0 15px 0 0" }}>
            <Item style={{ flex: 0.25 }}>#</Item>
            <Item style={{ flex: 1 }}>ID</Item>
            <Item style={{ flex: 2 }}>Address</Item>
            <Item style={{ flex: 1 }}>Auction Date</Item>
            <Item style={{ flex: 1 }}>File Date</Item>
            <Item style={{ flex: 2 }}>Appraised Value</Item>
            <Item style={{ flex: 0.5 }}>Year Built</Item>
            <Item style={{ flex: 0.75 }}>Sq. Ft.</Item>
            <Item style={{ flex: 0.75 }}>Prop Type</Item>
            </Prop>
        </div>
        <div style={{ width: '90%',  maxHeight: '250px', overflowY: 'scroll' }}>

            {properties.map((value: any, idx: any) => (
            (!showmissingdeeds ||(showmissingdeeds && !properties[idx].deedexists)?
            <Prop
                style={{
                color: idx == selectedIdx ? '#bf40bf' : '#000000'
                }}
                key={`userkey${idx}${showmissingdeeds}`}
                onClick={() => {
                selectProp(idx)
                }}
            >
                <Item key={`keyprop_${idx}_1`} style={{ flex: 0.25 }}>{idx+1}</Item>
                <Item key={`keyprop_${idx}_id`} style={{ flex: 1 }}>{value.foreclosureid.substring(0,12)}</Item>
                <Item key={`keyprop_${idx}_street`} style={{ flex: 2 }}>{`${value.street}, ${value.city}, ${value.zip}`}</Item>
                <Item key={`keyprop_${idx}_aucdt`} style={{ flex: 1 }}>{formatDate(new Date(value.auctiondate), "M/d/Y")}</Item>
                <Item key={`keyprop_${idx}_fldt`} style={{ flex: 1 }}>{value.filedate}</Item>
                <Item key={`keyprop_${idx}_aprval`} style={{ flex: 2 }}>{value.appraisedvalue}</Item>
                <Item key={`keyprop_${idx}_yearbuilt`} style={{ flex: 0.5 }}>{value.yearbuilt}</Item>
                <Item key={`keyprop_${idx}_improvementarea`} style={{ flex: 0.75 }}>{value.improvementarea}</Item>
                <Item key={`keyprop_${idx}_type`} style={{ flex: 0.75 }}>{value.type}</Item>
            </Prop>:<></>
            )
            ))}
        </div>
        <Row>
        <Column>

        <div style={{margin:"10px 0", width: '95%'}}>
            {
                properties.length>0&&selectedIdx>=0?<>
                <Header style={{fontSize:'16px'}}>Details</Header>
                <InputComp id="foreclosuretype"
                value = {foreclosuretype}
                onChange={(e: any)=>setforeclosuretype(e.target.value)}
                placeholder='foreclosure type (mortgage or hoa)'
                />
                
                <ButtonContainer>
                    <InputComp id="ownerid" value={ownername} onChange={(e:any)=>setownername(e.target.value)} placeholder={"owner name"} />
                    <InputComp id="proptypeid" value={propertytype} onChange={(e:any)=>setpropertytype(e.target.value)} placeholder={"property type"} />

                </ButtonContainer>
                <InputComp id="legaldescid" value={legaldescription} onChange={(e)=>setlegaldescription(e.target.value)} placeholder={"legal description"} width={250}/>
                <ButtonContainer>
                <InputComp id="lotid" value={lot} onChange={(e)=>setlot(e.target.value)} placeholder={"lot"} width={100}/>
                <InputComp id="blockid" value={block} onChange={(e)=>setblock(e.target.value)} placeholder={"block"} width={100}/>
                <InputComp id="blockid" value={subdivision} onChange={(e)=>setsubdivision(e.target.value)} placeholder={"subdivision"} width={250}/>
                </ButtonContainer>


                    <InputComp id="addressid" value={address} onChange={changeaddress} placeholder={"address(street, city, state, zip)"} width={250}/>
                    <InputComp id="streetid" value={street} onChange={(e:any)=>setstreet(e.target.value)} placeholder={"street"} width={250}/>

                <ButtonContainer>
                    <InputComp id="cityid" value={addrcity} onChange={(e:any)=>setaddrcity(e.target.value)}  placeholder={"city"} width={150}/>
                    <InputComp id="stateid" value={state} onChange={(e:any)=>setstate(e.target.value)}  placeholder={"state"} width={50}/>

                    <InputComp id="zipid" value={zip} onChange={(e:any)=>setzip(e.target.value)} placeholder={"zip"} width={75}/>

                    <InputComp id="yearbuiltid" value={yearbuilt} onChange={(e:any)=>setyearbuilt(e.target.value)} placeholder={"year built"} width={75}/>

                </ButtonContainer>
                <ButtonContainer>
                    <InfoHeader>notice url</InfoHeader>
                    <InfoItem><Link href ={properties[selectedIdx].noticelink} target="_blank"> &nbsp;&nbsp;{`notice link`} </Link></InfoItem>
                    <InputComp id="noticelinkid" placeholder="Notice link" value={noticelink} onChange={(e: any)=>setnoticelink(e.target.value)} />
                </ButtonContainer>

                <ButtonContainer>
                    <InputComp id="deednumberid" value={deednumber} onChange={(e:any)=>setdeednumber(e.target.value)} placeholder={"deed number"} width={175}/>

                    <InputComp id="deeddateid" value={deeddate} onChange={(e:any)=>setdeeddate(e.target.value)} placeholder={"deed date"} width={100} />
                </ButtonContainer>
                

                <ButtonContainer>
                    <InputComp id="proplinkid" value={propertyid} onChange={(e: any)=>setpropertyid(e.target.value)} placeholder={"county prop id"} width={100} />&nbsp;&nbsp;
                </ButtonContainer>

                <ButtonContainer>

                    <ButtonContainer>
                        <InputComp value={lienamount} onChange={(e:any)=>setlienamount(e.target.value)} id={"lienamountid"} placeholder="lien amount" width={100}/>
                        <InputComp value={lienyear} onChange={(e:any)=>setlienyear(e.target.value)} id={"lienyearid"} placeholder="lien year" width={75}/>
                    </ButtonContainer>

                    <ButtonContainer>
                        <InputComp value={assessedValue} onChange={(e:any)=>setassessedValue(e.target.value)} id={"assessedvalueid"} placeholder="(year) appraised value" width={175}/>
                        <InputComp value={improvementarea} onChange={(e:any)=>setimprovementarea(e.target.value)} id={"improvementid"} placeholder="improvement area" width={100}/>
                        <InputComp value={beds} onChange={(e:any)=>setbeds(e.target.value)} id={"beds"} placeholder="beds" width={50}/>
                        <InputComp value={baths} onChange={(e:any)=>setbaths(e.target.value)} id={"bathsid"} placeholder="baths" width={50}/>
                    </ButtonContainer>
                </ButtonContainer>
                <ButtonContainer>
                    <InputComp value={trusteename} onChange={(e:any)=>settrusteename(e.target.value)} id={"trusteenameid"} placeholder="trustee name" width={100}/>
                    <InputComp value={trusteephone} onChange={(e:any)=>settrusteephone(e.target.value)} id={"trusteephoneid"} placeholder="trustee phone" width={100}/>
                    
                </ButtonContainer>
                <ButtonContainer>
                  <InputComp value={noticeFileName} onChange={(e:any)=>{}} id={"noticeFileNameid"} placeholder="Notice FileName" width={350}/>
                </ButtonContainer>

                <ButtonContainer>
							<span>
								<input id = "10_o" type="checkbox" checked={tenam} onChange={()=>changeauctiontime(10)} />
								<label htmlFor="10_o" >10 AM</label>
							</span>
							<span>
								<input id = "11_o" type="checkbox" checked={elevenam} onChange={()=>changeauctiontime(11)} />
								<label htmlFor="11_o" >11 AM</label>
							</span>
							<span>
								<input id = "12_o" type="checkbox" checked={twelveam} onChange={()=>changeauctiontime(12)} />
								<label htmlFor="12_o" >12 PM</label>
							</span>
							<span>
								<input id = "1_o" type="checkbox" checked={oneam} onChange={()=>changeauctiontime(1)} />
								<label htmlFor="1_o" >1 PM</label>
							</span>
						</ButtonContainer>
						<InputComp id="ac_time_input" placeholder="auction time" value={auctiontime} onChange={(e: any)=>setauctiontime(e.target.value)}/>
                <TextboxComp id="tb_desc" value={propdesc} onChange={(e:any)=>setpropdesc(e.target.value)} rows={5} cols={50} width={300} placeholder="property description"/>
                <Button text="update" handleClick={updatepropinfo} />

                </>:<></>
            }
        </div>
        </Column>
        <Column style={{height:"100%", borderLeft:'1px solid black'}}>
		{selectedIdx>=0 && countyname=="Cook County"?<>
				<InputComp id="cc_pin" key="cc_pin" placeholder='pin' value={propertyid} onChange={(e: any)=>setpropertyid(e.target.value)} />
				<InputComp id="cc_street" key="cc_street" placeholder='street' value={street} onChange={(e: any)=>setstreet(e.target.value) } />
				<InputComp id="cc_city" key="cc_city" placeholder='city' value={addrcity} onChange={(e: any)=>setaddrcity(e.target.value) } />
				<InputComp id="cc_zip" key="cc_zip" placeholder='zip' value={zip} onChange={(e: any)=>setzip(e.target.value) } />
				<ButtonContainer>
					<Button text="Res Data" handleClick={()=>{getResidentialData(propertyid)}} />
					<Button text="Condo Data" handleClick={()=>{getCondoData(propertyid)}} />
					<Button text="Appraisal Data" handleClick={()=>{getAppraisalData(propertyid)}} />
					<Button text="Find PIN" handleClick={()=>{getPinFromAddress(street, addrcity, zip)}} />
					<Button text="clear" handleClick={()=>{setapiresult("")}} />
					
				</ButtonContainer>
				{
					apiloading?<LoadingComponent />:<></>
				}
				<TextboxComp 
					id="cc_api_result"
					placeholder='api result'
					rows={10}
					cols={10}
					onChange={()=>{}}
					width= {450}
					height={450}
					value={JSON.stringify(apiresult)}
				/>
            	<HorizontalLine />
				</>:<></>}


            {properties.length>0 && selectedIdx>=0?
            
            // properties[selectedIdx].images && properties[selectedIdx].images.length>0?
            <>
            <TextboxComp id="noticeinfoid" placeholder="foreclosure notice" value={notice} onChange={(e: any)=> setnotice(e.target.value)} cols={50} rows={50} width={350} height={300} />

            <HorizontalLine />
            <div style={{width: "100%"}}>
                <TextboxComp id="deedsearchtextid" placeholder="deed search text" value={deedsearchtext} onChange={(e: any)=> setdeedsearchtext(e.target.value)} width={350} cols={50} rows={50} height={300}/>
                <ButtonContainer>

                <SmallButton text="load title file" handleClick={loadtitlefile} />
                <SmallButton text="create pdf" handleClick={()=>createtitlePDF(properties[selectedIdx].foreclosureid)} />
                <SmallButton text="insert doc block" handleClick={()=>insertdocblock()} />
                </ButtonContainer>
            </div>
            <HorizontalLine />

            <Header style={{fontSize:'16px'}}>Images</Header>
            {`image: ${currentimageidx+1} / ${properties[selectedIdx].images.length}`}
            <BasicImage>
                <img src = {imageurl} style={{width:"90%", height: "90%"}} />
            </BasicImage>
            <ButtonContainer>
                <SmallButton text="prev" handleClick={showpreviousimage} />
                <SmallButton text="next" handleClick={shownextimage} />
            </ButtonContainer>

            </>
            
            :<></>
            }
			
        </Column>
        </Row>
    </MainContainer>
  );
}


const MainContainer = styled.div`
  margin: 25px;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  width: 90%;
  color: #000000;
  min-height: 50vh;
`
const Column = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
`
const Header = styled.div`
  display: flex;
  font-size: 25px;
  font-weight: 700;
  color: black;
`
const Prop = styled.div`
  display: flex;
  border: 1px solid gray;
  justify-content: center;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
    justify-content: flex-start;
  }
  &:hover {
    background-color: #f0f0f0;
  }
`

const Item = styled.div`
  display: flex;
  padding: 5px;
  font-size: 12px;
  flex-wrap: wrap;
  overflow: hidden;
  height: auto;
  align-items: center;
  word-break: wrap;
  // color: black;
`

const InfoHeader = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  margin: 3px 10px 0 0;
  align-items: center;
`;

const InfoItem = styled.div`
  margin: 3px 0;
  display: flex;
  font-size: 14px;
  font-weight: 300;
  align-items: center;
`;

const Link =  styled.a`
  color: #3366CC;
`;

const BasicImage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  font-weight: 600;
  height: min(250px, 45vh);
  width: 90%;
  max-height: 500px;
  align-items: center;
  justify-content: center;
`

const UploadInput = styled.input`
  margin: 5px;
  text-align: center;
  opacity: 0;
  display: none;
`;

const Label = styled.label`
  color: #bf40bf;
  margin: 5px;
  background-color: #eee;
  font-size: 16px;
  flex-wrap: wrap;
  padding: 5px;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    font-weight: 700;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-all;
`;

const Row = styled.div`
  display: flex;
`;

const Span = styled.span`
    display: flex;
    align-items: center;
`;

export default DisplayListingComps